import { render, staticRenderFns } from "./AdminQuillEditor.vue?vue&type=template&id=b282b504&"
import script from "./AdminQuillEditor.vue?vue&type=script&lang=js&"
export * from "./AdminQuillEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports